export default "__VITE_ASSET__Dp$yH$V2__"